exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "span.main {\n  display:inline-block;\n  margin:0.5ex 1ex;\n  padding:0.5ex 1ex;\n  border: 2px solid black;\n  border-radius: 12px;\n}\n\nspan.select {\n  cursor: pointer;\n}\n\nbutton.delete {\n  font-weight: bold;\n  color: red;\n}\n\nspan.isSelected {\n  background: yellow;\n}\n\nlabel:hover {\n  text-decoration: underline;\n  cursor: pointer;\n}\n", ""]);

// exports


/*** EXPORTS FROM exports-loader ***/
module.exports = module.exports.toString();


//////////////////
// WEBPACK FOOTER
// ./src/app/tag-button/tag-button.component.css
// module id = 403
// module chunks = 0